<div class="d-flex justify-content-center" :class="addClass"><div class="preloader" :class="addClassPreloader"></div></div>